import {action, makeObservable, observable} from 'mobx';
import {v4 as uuid} from 'uuid';

export class FileUpload {
  public progress = 0;

  public aborted = false;

  public readonly id: string;

  public readonly name: string;

  private _abort: (() => void) | undefined;

  public constructor({
    abort,
    name,
    id,
  }: {
    abort?: () => void;
    name: string;
    id?: string;
  }) {
    makeObservable(this, {
      progress: observable,
      aborted: observable,
      setProgress: action.bound,
      setAbort: action.bound,
      abort: action.bound,
    });

    this._abort = abort;
    this.name = name;
    this.id = id || uuid();
  }

  public setProgress(progress: number): void {
    this.progress = progress;
  }

  public abort(): void {
    this.aborted = true;
    this._abort?.();
  }

  public setAbort(abort: () => void): void {
    this._abort = abort;
  }
}
